// src/components/battle/ModeSection.jsx
export default function ModeSection({ value, onChange }) {
  return (
    <section className="mb-4 text-sm">
      <label className="block mb-2 font-medium">대결 방식</label>

      <div className="flex gap-3">
        {/* 개인전 */}
        <label
          className={`
            flex-1 text-center cursor-pointer
            rounded-xl border px-4 py-3
            transition
            ${
              value === "SOLO"
                ? "border-[rgb(0,224,198)] bg-[rgb(0,224,198)]/10 text-[rgb(0,224,198)] font-semibold"
                : "border-slate-200 bg-gray-50 text-slate-600 hover:bg-gray-100"
            }
          `}
        >
          <input
            type="radio"
            name="mode"
            value="SOLO"
            checked={value === "SOLO"}
            onChange={() => onChange("SOLO")}
            className="hidden"
          />
          개인전
        </label>

        {/* 팀전 */}
        <label
          className={`
            flex-1 text-center cursor-pointer
            rounded-xl border px-4 py-3
            transition
            ${
              value === "TEAM"
                ? "border-[rgb(0,224,198)] bg-[rgb(0,224,198)]/10 text-[rgb(0,224,198)] font-semibold"
                : "border-slate-200 bg-gray-50 text-slate-600 hover:bg-gray-100"
            }
          `}
        >
          <input
            type="radio"
            name="mode"
            value="TEAM"
            checked={value === "TEAM"}
            onChange={() => onChange("TEAM")}
            className="hidden"
          />
          팀전
        </label>
      </div>
    </section>
  );
}
